import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { ModalService, useMobileScreenCheck } from "../modal";
import { MobileActionDialog } from "../mobileActionDialog";
import { Icon } from "../icon/Icon";
import { useIntlTranslate } from "../../hooks";

import "./DeviceActionsDialog.scss";

/**
 * deviceName and ariaDeviceName could have different values
 * in some cases deviceName is a device identifier and we don't want that in aria-label
 */
export const DeviceActionsToggle = ({
  deviceName,
  menuItems,
  ariaDeviceName,
}) => {
  const translate = useIntlTranslate();

  const ariaLabel = ariaDeviceName
    ? translate("aria_named_device_actions", {
        deviceName: ariaDeviceName,
      })
    : translate("aria_device_actions");

  return (
    <UnstyledButton
      className="device-menu__toggle-button"
      onClick={() =>
        openModal(deviceName, menuItems)
          .then(() => null)
          .catch(() => null)
      }
      aria-label={ariaLabel}
    >
      <Icon icon="fa-solid fa-ellipsis-v" />
    </UnstyledButton>
  );
};

const openModal = (deviceName, menuItems) =>
  ModalService.show((modal) => ({
    dialog: (
      <DeviceActionsDialog
        deviceName={deviceName}
        menuItems={menuItems}
        modal={modal}
      />
    ),
  }));

export const DeviceActionsModalItem = ({ id, children, disabled, action }) => {
  return (
    <UnstyledButton
      onClick={action}
      id={id}
      className={classnames({ "item--disabled": disabled })}
    >
      {children}
    </UnstyledButton>
  );
};

const DeviceActionsDialog = ({ deviceName, menuItems, modal }) => {
  const collapse = () => modal.reject();

  useMobileScreenCheck(collapse);

  return (
    <MobileActionDialog
      headerText={deviceName}
      items={menuItems}
      onClose={collapse}
    />
  );
};

DeviceActionsDialog.propTypes = {
  menuItems: PropTypes.array.isRequired,
  deviceName: PropTypes.string,
};
